export const assessments = {
  week1: {
    title: "Assessment",
    subtitle:
      "Let's test your knowledge on Your “Why” and Motivation for University",
    questions: [
      {
        id: 1,
        question: `What does your “Why” represent in the journey to university?`,
        options: [
          { id: "A", text: "The subjects you enjoy the most." },
          { id: "B", text: "The reason you want to go to university." },
          { id: "C", text: "The degree you plan to earn." },
          { id: "D", text: "The university you want to attend." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "Why is it important to have a clear “Why” before starting university?",
        options: [
          {
            id: "A",
            text: "It helps you choose your favorite extracurriculars.",
          },
          { id: "B", text: "It helps you impress your lecturers." },
          { id: "C", text: "It keeps you motivated when challenges arise." },
          { id: "D", text: "It guarantees you’ll get top grades." },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question: "Which of the following is NOT an example of a strong “Why”?",
        options: [
          { id: "A", text: "To build a future career." },
          { id: "B", text: "To discover who I am." },
          { id: "C", text: "Because it’s expected of me." },
          { id: "D", text: "To make a difference in my community." },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question:
          "What should you do if your “Why” doesn’t feel strong enough after facing a challenge?",
        options: [
          { id: "A", text: "Ignore it and move on." },
          { id: "B", text: "Drop out and try again later." },
          {
            id: "C",
            text: "Review and strengthen your reason for choosing this path.",
          },
          { id: "D", text: "Ask someone else to give you a new “Why”." },
        ],
        correctOption: "C",
      },
      {
        id: 5,
        question: "What happens when your “Why” is clear and strong?",
        options: [
          { id: "A", text: "You never face any challenges." },
          { id: "B", text: "You always get perfect grades." },
          {
            id: "C",
            text: "You stay focused and motivated through difficulties.",
          },
          { id: "D", text: "You no longer need help or support." },
        ],
        correctOption: "C",
      },
    ],
  },
  week2: {
    title: "Assessment",
    subtitle: "Let's test your knowledge on Mindset and Values",
    questions: [
      {
        id: 1,
        question: `What does your mindset refer to?`,
        options: [
          { id: "A", text: "The way you dress and behave." },
          { id: "B", text: "The way you think and respond to challenges." },
          { id: "C", text: "The kind of people you make friends with." },
          { id: "D", text: "The grades you get in school." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question: "Which of the following best describes a fixed mindset?",
        options: [
          {
            id: "A",
            text: "Believing that abilities can be developed with effort.",
          },
          { id: "B", text: "Seeing failure as a learning opportunity." },
          {
            id: "C",
            text: "Believing that intelligence and talent cannot change.",
          },
          { id: "D", text: "Being open to feedback and improvement." },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question:
          "What happens when you face challenges and choose to try again instead of giving up?",
        options: [
          { id: "A", text: "Your brain gets tired." },
          {
            id: "B",
            text: "Your brain grows stronger and learns to think differently.",
          },
          { id: "C", text: "You become more afraid of failure." },
          { id: "D", text: "You lose motivation." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question: "What are values?",
        options: [
          { id: "A", text: "Things you enjoy doing for fun." },
          {
            id: "B",
            text: "The principles that guide your decisions and actions.",
          },
          { id: "C", text: "Rules made by your parents and teachers." },
          { id: "D", text: "Your achievements and grades in school." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question: "What happens when your mindset and values work together?",
        options: [
          { id: "A", text: "You become confused about your goals." },
          { id: "B", text: "You lose focus on what’s important." },
          {
            id: "C",
            text: "They help you make better decisions and handle challenges wisely.",
          },
          { id: "D", text: "You depend more on others for advice." },
        ],
        correctOption: "C",
      },
    ],
  },
  week3: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "You’ve just met a group of new students in your hostel. They’re fun to be around, but they often skip lectures and mock those who study. You enjoy their company, but you’re worried about your grades. What’s the smartest decision to make?",
        options: [
          {
            id: "A",
            text: "Keep hanging out with them since you can always study later..",
          },
          { id: "B", text: "Stop talking to them completely and stay alone." },
          {
            id: "C",
            text: "Limit your time with them and find friends who share your academic goals.",
          },
          {
            id: "D",
            text: "Skip lectures too, one or two absences won’t matter.",
          },
        ],
        correctOption: "C",
      },
      {
        id: 2,
        question:
          "You and your roommate disagree on how to keep your shared space tidy. He keeps leaving his things around, and it’s bothering you. What should you do?",
        options: [
          { id: "A", text: "Shout at him so he understands you’re serious." },
          { id: "B", text: "Complain about him to other roommates." },
          {
            id: "C",
            text: "Have a calm conversation and agree on clear rules for your space.",
          },
          { id: "D", text: "Ignore it completely; he’ll change eventually." },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question:
          "A classmate always borrows your notes and never shares hers. You’re starting to feel used. What’s the best way to handle it?",
        options: [
          { id: "A", text: "Keep lending her your notes so she likes you." },
          {
            id: "B",
            text: "Set boundaries and politely tell her you’d like a fair exchange next time.",
          },
          { id: "C", text: "Gossip about her to your friends." },
          { id: "D", text: "Stop talking to her altogether." },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question:
          "Your friend always calls you “boring” because you’d rather study than go out. You’re beginning to feel bad about yourself. What should you do?",
        options: [
          { id: "A", text: "Go out to prove you’re fun." },
          {
            id: "B",
            text: "Remember your priorities and stick to what’s best for you.",
          },
          { id: "C", text: "Stop being friends with anyone who studies." },
          { id: "D", text: "Apologize for focusing on school." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "Your coursemate invites you to an outing that will cost most of your month’s allowance. You’d love to go, but you also need to buy a textbook for your course. What’s the best choice?",
        options: [
          {
            id: "A",
            text: "Go for the outing; experiences are more important than books.",
          },
          {
            id: "B",
            text: "Buy the textbook first and plan outings that fit your budget later.",
          },
          { id: "C", text: "Ask your parents for more money." },
          { id: "D", text: "Skip both, it’s too stressful to decide." },
        ],
        correctOption: "B",
      },
    ],
  },
  week4: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Tola just got into university and is thrilled to finally make her own choices. She spends most nights hanging out with friends and skips early morning lectures because “no one is checking.” What’s the best advice for her?",
        options: [
          {
            id: "A",
            text: "Enjoy your freedom, you can always catch up later.",
          },
          {
            id: "B",
            text: "Freedom is great, but showing up for classes is part of being responsible.",
          },
          { id: "C", text: "Focus on fun; grades don’t define success." },
          { id: "D", text: "Sleep in, health matters more than classes." },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "David decides to join three student clubs, a football team, and a campus fellowship, all while juggling classes. He’s constantly tired and missing deadlines. What should he do?",
        options: [
          { id: "A", text: "Quit everything and focus only on academics." },
          {
            id: "B",
            text: "Reassess his schedule and set priorities for better balance.",
          },
          {
            id: "C",
            text: "Keep pushing himself, university is supposed to be hectic.",
          },
          { id: "D", text: "Drop out of school temporarily." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question:
          "Amara’s roommates invite her to a big weekend party, but she has an exam on Monday. She really wants to go, but knows she isn’t prepared yet. What should she do?",
        options: [
          { id: "A", text: "Go anyway, she deserves a break." },
          { id: "B", text: "Study a little and then party all night." },
          {
            id: "C",
            text: "Prioritize studying first and plan to celebrate after the exam.",
          },
          { id: "D", text: "Avoid both, just sleep through the weekend." },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question:
          "Lara’s friends constantly pressure her to stay out late, even when she’s tired. She doesn’t want to lose them, so she always agrees. What skill does Lara need to practice more?",
        options: [
          { id: "A", text: "Time management." },
          { id: "B", text: "Setting healthy boundaries." },
          { id: "C", text: "Financial budgeting." },
          { id: "D", text: "Conflict resolution." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "Michael has the freedom to choose how to study. He prefers to wait until the night before exams to cram everything. He passes sometimes, but feels burnt out. What’s a better way to handle his academic freedom?",
        options: [
          { id: "A", text: "Keep doing what works, he’s still passing." },
          {
            id: "B",
            text: "Build consistent study habits to manage freedom effectively.",
          },
          { id: "C", text: "Study only when he feels like it." },
          { id: "D", text: "Rely on friends’ summaries." },
        ],
        correctOption: "B",
      },
    ],
  },
  week5: {
    title: "Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Tola moved into the university hostel and misses her family badly. She spends hours crying and refuses to make new friends. What’s the best resilient response?",
        options: [
          { id: "A", text: "Keep to herself until she feels better." },
          {
            id: "B",
            text: "Stay connected with family while building new friendships to adjust.",
          },
          { id: "C", text: "Go home every weekend to avoid loneliness." },
          {
            id: "D",
            text: "Ignore her feelings and pretend everything is fine.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question:
          "John failed his first university test and feels like giving up. What should he do to show resilience?",
        options: [
          { id: "A", text: "Blame the lecturer for being too strict." },
          {
            id: "B",
            text: "Review what went wrong, ask for help, and try a new study plan.",
          },
          { id: "C", text: "Stop attending the class completely." },
          { id: "D", text: "Compare his score to others." },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question:
          "Amaka joined a new department but feels like she doesn’t belong because everyone already knows each other. What’s the best thing to do?",
        options: [
          { id: "A", text: "Avoid everyone until someone approaches her." },
          {
            id: "B",
            text: "Join a study group or club to meet people with similar interests.",
          },
          { id: "C", text: "Drop the course and switch departments." },
          {
            id: "D",
            text: "Only hang out with her old friends from secondary school.",
          },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question:
          "Sarah says, “I want to do better next semester.” What’s wrong with this goal?",
        options: [
          { id: "A", text: "It’s not big enough." },
          { id: "B", text: "It’s not SMART." },
          { id: "C", text: "It’s too difficult." },
          { id: "D", text: "It’s too time-bound." },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "Chika sets a goal to “become a millionaire this semester.” What makes this goal unrealistic?",
        options: [
          { id: "A", text: "It’s not time-bound." },
          { id: "B", text: "It’s not achievable given her current resources." },
          { id: "C", text: "It’s not measurable." },
          { id: "D", text: "It’s not relevant." },
        ],
        correctOption: "B",
      },
      {
        id: 6,
        question:
          "After failing a course, Blessing says, “I’m not good enough for this department.” What mindset is she displaying?",
        options: [
          { id: "A", text: "Growth mindset." },
          { id: "B", text: "Fixed mindset." },
          { id: "C", text: "Responsible mindset." },
          { id: "D", text: "Positive mindset." },
        ],
        correctOption: "B",
      },
      {
        id: 7,
        question: "When challenges arise, resilient students usually:",
        options: [
          { id: "A", text: "Avoid the situation completely." },
          { id: "B", text: "Learn from setbacks and keep trying." },
          { id: "C", text: "Blame others for their problems." },
          { id: "D", text: "Pretend nothing happened." },
        ],
        correctOption: "B",
      },
      {
        id: 8,
        question:
          "Ada sets a goal to “join a study group to improve her grades before the end of the semester.” What type of goal is this?",
        options: [
          { id: "A", text: "Short-term goal." },
          { id: "B", text: "Long-term goal." },
          { id: "C", text: "Impossible goal." },
          { id: "D", text: "Non-academic goal." },
        ],
        correctOption: "A",
      },
      {
        id: 9,
        question:
          "If Chioma wants to overcome her fear of public speaking, which goal is SMART?",
        options: [
          { id: "A", text: "I’ll try to be more confident." },
          {
            id: "B",
            text: "I’ll practice speaking for 5 minutes every week for two months.",
          },
          { id: "C", text: "I’ll stop being afraid." },
        ],
        correctOption: "B",
      },
      {
        id: 10,
        question:
          "Emmanuel values honesty but lies to his lecturer about missing an assignment. What does this show?",
        options: [
          { id: "A", text: "His values are not important." },
          {
            id: "B",
            text: "His actions are not aligned with his stated values.",
          },
          { id: "C", text: "He values responsibility more." },
          { id: "D", text: "His lecturer is too strict." },
        ],
        correctOption: "B",
      },
    ],
  },
};
